<template>
	<el-dialog
		title="Cambio de clave"
		width="500px"
		:visible.sync="show"
		@close="onClosed"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
	>
		<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="85px">
			<p>Por cuestiones de seguridad es necesario que cambie su clave.</p>
			<el-form-item prop="actPass" label-width="135px">
				<el-input type="hidden" v-model="ruleForm.actPass" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="Contraseña Nueva" prop="pass" label-width="135px">
				<el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="Repita Contraseña" prop="checkPass" label-width="135px">
				<el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" style="display: flex; justify-content: space-between;">
			<el-button @click="show = false">Más tarde</el-button>
			<el-button type="primary" :loading="guardando" @click="onSubmit">Guardar</el-button>
		</span>
	</el-dialog>
</template>
<script>
export default {
	name: 'change',
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		var validatePass = (rule, value, callback) => {
			if (value.length < 6) callback(new Error('Mínimo 6 caracteres'));
			else if (this.ruleForm.checkPass !== '') this.$refs.ruleForm.validateField('checkPass');
			callback();
		};
		var validatePass2 = (rule, value, callback) => {
			if (value !== this.ruleForm.pass) callback(new Error('Las contraseñas no coinciden'));
			else callback();
		};
		return {
			show: false,
			guardando: false,
			ruleForm: {
				pass: '',
				checkPass: '',
				actPass: '$%&',
			},
			rules: {
				pass: [{ validator: validatePass, trigger: 'blur' }],
				checkPass: [{ validator: validatePass2, trigger: 'blur' }],
			},
		};
	},
	watch: {
		visible(v) {
			this.show = v;
		},
		userdata(v) {
			this.ruleForm.first_name = v.first_name;
			this.ruleForm.last_name = v.last_name;
		},
	},
	computed: {
		userdata() {
			return this.$store.state.perfil.userdata;
		},
	},
	methods: {
		onSubmit() {
			this.$refs['ruleForm'].validate(valid => {
				if (valid) {
					this.guardando = true;
					let params = {
						url: './api/public/proxy/data',
						data: this.$refs['ruleForm'].model,
					};
					this.$store.dispatch('setPerfil', params).then(response => {
						if (!response.data.success) {
							this.$message({
								type: 'error',
								message: response.data.msg,
							});
						} else {
							this.$message({
								type: 'success',
								message: response.data.msg,
							});
							this.show = false;
						}
						this.guardando = false;
					});
				} else return false;
			});
		},
		onClosed() {
			this.$emit('closed');
		},
	},
};
</script>
<style></style>
